export default {
    'eventUser.ok_user': 'filterOkUser',
    'eventUser.ok_manager': 'filterOkManager',
}
